import styled from "styled-components";
import { colors, spacing, textStyles } from "design-system/foundation";
import { BadgeSize } from "./badge-new-feature.types";

const sizeStyles: Record<BadgeSize, string> = {
  sm: `
    padding: ${spacing["2xs"]} ${spacing.sm};
    font-family: ${textStyles.caption.caption8.fontFamily};
    font-size: ${textStyles.caption.caption8.fontSize};
    line-height: ${textStyles.caption.caption8.lineHeight};
    font-weight: ${textStyles.caption.caption8.fontWeight};
  `,
  md: `
    padding: ${spacing.xs} ${spacing.md};
    font-family: ${textStyles.caption.caption7.fontFamily};
    font-size: ${textStyles.caption.caption7.fontSize};
    line-height: ${textStyles.caption.caption7.lineHeight};
    font-weight: ${textStyles.caption.caption7.fontWeight};
  `
};

export const BadgeContainer = styled.span<{ $size: BadgeSize }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: ${colors.bg.error.primaryBold};
  color: ${colors.text.base.invert};
  white-space: nowrap;
  ${({ $size }) => sizeStyles[$size]}
`;
